import React, { Component } from "react";
import { Helmet } from "react-helmet";
import logo from "../../assets/logo.png";
import Navbar from "../Navbar/Navbar";
import LoanClosurePolicyContent from "./LoanClosurePolicyContent";
import BottomBar from "../BottomBar/BottomBar";
class LoanClosurePolicy extends Component {
  render() {
    return (
   
        <div id='terms' className="main">
          <Helmet>
            <title>Loan Closure Policy | MoneyMonk</title>
            <meta name="description" content="Understand MoneyMonk's loan closure policy, including prepayment terms and procedures for closing your personal loan." />
            <link rel="canonical" href="https://moneymonkapp.in/loanclosurepolicy" />
          </Helmet>
          <Navbar imageData={logo} />
          <LoanClosurePolicyContent />
          <BottomBar />
        </div>

    );
  }
}

export default LoanClosurePolicy;
